// Environment variable check utility

// This function checks for the existence of required environment variables
// and logs warnings if they're missing
export const checkEnvironmentVariables = () => {
  console.log("===== Environment Variable Check =====");
  
  // Check Supabase variables
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  
  console.log("REACT_APP_SUPABASE_URL:", supabaseUrl || "MISSING");
  console.log("REACT_APP_SUPABASE_ANON_KEY exists:", !!supabaseAnonKey);
  
  // Check proxy variables
  const proxyUrl = process.env.REACT_APP_PROXY_URL;
  const proxyAnonKey = process.env.REACT_APP_PROXY_ANON_KEY;
  
  console.log("REACT_APP_PROXY_URL:", proxyUrl || "MISSING");
  console.log("REACT_APP_PROXY_ANON_KEY exists:", !!proxyAnonKey);
  
  // Return true if all required variables are present
  return !!(supabaseUrl && supabaseAnonKey && proxyUrl);
};

export default checkEnvironmentVariables; 